import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../_core/_services/notification.service';
import { PublicFaqItemDto } from '../../_core/_model/support/support';
import { SupportService } from '../../_core/_services/support/support.service';
import { Observable } from 'rxjs';
import { AuthService } from '../../_core/_services/auth.service';

@Component({
  selector: 'app-help-center',
  standalone: false,
  templateUrl: './help-center.html',
  styleUrl: './help-center.css'
})
export class HelpCenter implements OnInit {
  loading = false;
  faqs: PublicFaqItemDto[] = [];
  filteredFaqs: PublicFaqItemDto[] = [];
  query = '';
  selectedCategory = 'All';
  isLoggedIn$: Observable<boolean>;

  get categories(): string[] {
    const values = Array.from(new Set(this.faqs.map(x => x.category))).sort();
    return ['All', ...values];
  }

  constructor(
    private supportService: SupportService,
    private authService: AuthService,
    private notifyService: NotificationService
  ) {
    this.isLoggedIn$ = this.authService.isLoggedIn$;
  }

  ngOnInit(): void {
    this.loadFaqs();
  }

  openTicket() {
  }

  loadFaqs(): void {
    this.loading = true;

    this.supportService.getFaqs().subscribe({
      next: (res) => {
        this.faqs = res.data || [];
        this.applyFilters();
      },
      error: (err) => {
        this.faqs = [];
        this.filteredFaqs = [];
        this.notifyService.showError(
          err?.error?.message || 'Failed to load help center.',
          'Error'
        );
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  applyFilters(): void {
    const term = this.query.trim().toLowerCase();

    this.filteredFaqs = this.faqs.filter(item => {
      const matchesCategory =
        this.selectedCategory === 'All' || item.category === this.selectedCategory;

      const matchesQuery =
        !term ||
        item.category.toLowerCase().includes(term) ||
        item.question.toLowerCase().includes(term) ||
        item.answer.toLowerCase().includes(term);

      return matchesCategory && matchesQuery;
    });
  }

  clearFilters(): void {
    this.query = '';
    this.selectedCategory = 'All';
    this.applyFilters();
  }
}